// Packages
import React from "react";

// Components
import useComponents from "../../../../components";

// Controlled
import useControllers from "../../../../../controllers";

const ReferredCreate = () => {
  // Components
  const { ContentWrappers, CardWrapper, Typography, TextFieldControlled, useButtons, useModals } =
    useComponents();
  const { DefaultButton } = useButtons();
  const { DefaultModal } = useModals();

  // Controlled
  const { useScreenHooks } = useControllers();
  const { useTools } = useScreenHooks();
  const { useReferred } = useTools();
  const { useReferredCreate } = useReferred();
  const { control, onSubmit, handleSubmit, showModal, handleCloseModal, idTools } =
    useReferredCreate();

  return (
    <ContentWrappers gridColums={["1fr"]} contentWidth="892px" as="section">
      <CardWrapper padding="2rem">
        <Typography variant="h3">1. PASO DE CAPTACIÓN</Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ContentWrappers
            className="mt-6"
            gridColums={["1fr", "1fr"]}
            gap={{
              row: "0px",
              column: "32px",
            }}
          >
            <TextFieldControlled
              label="Número mínimo de referidos"
              type="number"
              control={control}
              id="min_referrals"
              placeholder=""
              name="min_referrals"
            />
            <TextFieldControlled
              type="number"
              label="Número máximo de referidos"
              control={control}
              placeholder=""
              id="max_referrals"
              name="max_referrals"
            />
          </ContentWrappers>
          <div className="flex justify-center mt-4">
            <DefaultButton type="submit" color="secondary">
              Finalizar y publicar
            </DefaultButton>
          </div>
        </form>
      </CardWrapper>
      <DefaultModal
        isOpen={showModal}
        handledButton={handleCloseModal}
        children={
          <div>
            Creación de referencia <b>{idTools}</b> se <br /> ha creado con éxito.
          </div>
        }
      />
    </ContentWrappers>
  );
};

export default ReferredCreate;
